import React from 'react'
import { UpdateCon } from './styles'
type UpdateParams = {
  message: string
}

export const EventUpdate: React.FC<React.PropsWithChildren<UpdateParams>> = ({
  message,
}) => {
  return (
    <UpdateCon>
      <p>{message}</p>
    </UpdateCon>
  )
}
